<div class="container">
  <ion-spinner name="bubbles" class="spinner"></ion-spinner>
  {{ loadingText }}
</div>
